let key = {};

key = {
  API_URL: "https://beleaftechnologies.com:3001",
  // API_URL: "http://localhost:3001",
};

export default { key };
